import strapi, { mapStrapiData } from '../lib/strapi';

import qs from 'qs';

const extractYear = (item) => {
  const p = item?.attributes || item;
  const dateStr = (p?.date_range || p?.year || '').toString();
  if (dateStr.toLowerCase().includes('present')) {
    const match = dateStr.match(/\d{4}/);
    return match ? parseInt(match[0], 10) + 1000 : 9999;
  }
  const matches = dateStr.match(/\d{4}/g);
  if (matches && matches.length > 0) {
    return Math.max(...matches.map(n => parseInt(n, 10)));
  }
  return 0;
};

export const getJourneyPageData = async () => {
  try {
    const query = qs.stringify({
      populate: {
        hero_image: true,
        problem_image: true,
        testimonials_list: { populate: '*' }
      }
    });
    const pageRes = await strapi.get(`/our-journey-page?${query}`);
    const projectsRes = await strapi.get('/projects?populate=*');

    const rawProjects = projectsRes?.data?.data || [];
    const sortedProjects = [...rawProjects].sort((a, b) => extractYear(b) - extractYear(a));

    return {
      content: mapStrapiData(pageRes),
      projects: sortedProjects,
    };
  } catch (error) {
    console.error('Error fetching Journey data:', error);
    return null;
  }
};